import { FaTimes } from 'react-icons/fa';
import PropTypes from 'prop-types';

const Clear = ({ handleClear }) => (
  <FaTimes className="inline-block ml-1 my-1 h-4 float-right" onClick={handleClear} />
);

Clear.propTypes = {
  handleClear: PropTypes.func.isRequired,
  // oxlint-disable-next-line react/forbid-prop-types
};

export default Clear;
